import Cookies from 'js-cookie';

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let sectionsToFetch = [];
      switch (submitButton.dataset.addToCartBehavior) {
        case ('open_cart_drawer'):
          sectionsToFetch = [
            ...this.cartDrawer.getSectionsToRender().map((section) => section.id)
          ];
          break;
        case ('show_cart_notification'):
          sectionsToFetch = [
            ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
            ...this.cartNotification.getSectionsToRender().map((section) => section.id)
          ];
          break;
        default:
          sectionsToFetch = [
            ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
            ...this.cartNotification.getSectionsToRender().map((section) => section.id)
          ];
          break;
      }

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      // Get the clicked recommendations array
      let clickedRecommendations = Cookies.get('clickedRecommendations') || [];
      clickedRecommendations = Array.isArray(clickedRecommendations) ? clickedRecommendations : JSON.parse(clickedRecommendations);

      // Check if the product id is in the clicked recommendations array
      if (clickedRecommendations.includes(formData.get('product_id'))) {
        console.log('Product is in the clicked recommendations array');
        formData.append('properties[_recommended]', 'true');
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          this.cartDrawer.renderContents(parsedState);

          // Load the cart drawer recommendations
          if (document.querySelectorAll('cart-drawer-recommend')) {
            document.querySelectorAll('cart-drawer-recommend').forEach((recommendEl) => {
              recommendEl.classList.remove('empty-cart');
              recommendEl.classList.add('reload');
            });
          }

          switch (submitButton.dataset.addToCartBehavior) {
            case ('open_cart_drawer'):
              this.cartDrawer.open();
              break;
            case ('show_cart_notification'):
            default:
              this.cartNotification.setActiveElement(document.activeElement);
              // this.cartNotification.renderContents(parsedState); // Disabled, no specific product message.
              this.cartNotification.open();
              this.notificationCloseTimeout && clearTimeout(this.notificationCloseTimeout);
              this.notificationCloseTimeout  = setTimeout(() => {
                this.cartNotification.close();
              }, 5000);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          setTimeout(() => {
            document.querySelector('cart-drawer')?.handleScrollHeight();
          }, 500);
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


